import type { FC } from "react";

import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import styles from "./navDropdown.module.scss";

interface NavDropdownProps {
	label: string;
	to: string;
	items: {
		to: string;
		label: string;
	}[];
}

export const NavDropdown: FC<NavDropdownProps> = ({ label, to, items }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={styles.dropdown} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
			<Link to={to} className={styles.dropdownLabel}>
				{label} <ChevronDown size={16} />
			</Link>
			{isOpen && (
				<div className={styles.dropdownMenu}>
					{items.map((item) => (
						<Link key={item.to} to={item.to} className={styles.dropdownItem}>
							{item.label}
						</Link>
					))}
				</div>
			)}
		</div>
	);
};
